export default "__VITE_ASSET__ghH202Mz__"